import * as React from "react";
import { InstantCollapsible } from "sb-resp-ui";
import { SecondaryHeading } from "../../components/SecondaryHeading";
import { HeadingTitle } from "../../components/HeadingTitle";
export class SecondaryHeadingContent extends React.PureComponent {
    renderSubheading() {
        return React.createElement(SecondaryHeading, { key: `subheading-${this.props.id}`, componentPrefix: this.props.cardType },
            React.createElement(HeadingTitle, { name: this.props.name, eventsCount: this.props.eventsCount }));
    }
    render() {
        return (React.createElement(InstantCollapsible, { key: `collapse-subheading-${this.props.id}`, initiallyExpanded: this.props.shouldExpand, trigger: this.renderSubheading(), content: React.createElement(React.Fragment, null, this.props.children) }));
    }
}
//# sourceMappingURL=SecondaryHeadingContent.js.map